export default "__VITE_ASSET__DhAxo7j$__"